

















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import gql from 'graphql-tag';
import store from '@/store';
import { parseError, UNKNOWN_ERROR } from '@/utils/errors.ts';

const signUpMutation = gql`
  mutation SignUp(
    $email: String!
    $password: String!
    $name: String!
    $centerId: ID!
  ) {
    createUser(
      email: $email
      password: $password
      name: $name
      centerId: $centerId
    )
  }
`;

const loginMutation = gql`
  mutation Login($usernameOrEmail: String!, $password: String!) {
    getAuthToken(usernameOrEmail: $usernameOrEmail, password: $password)
  }
`;

@Component({
  components: {},
})
export default class SignUp extends Vue {
  public centersQuery = gql`
    query Centers {
      centers {
        id
        name
      }
    }
  `;

  public username: string | null = null;
  public email: string | null = null;
  public password: string | null = null;
  public name: string | null = null;
  public centerId: string | null = null;

  private fieldErrors: { [key: string]: string } = {};
  private formError: string | null = null;

  private loading = false;

  public signUp() {
    this.validateFields();
    if (this.hasErrors) {
      return;
    }

    this.loading = true;
    this.$apollo
      .mutate({
        mutation: signUpMutation,
        variables: {
          email: this.email,
          password: this.password,
          name: this.name,
          centerId: this.centerId,
        },
      })
      .then((response) => {
        return this.$apollo
          .mutate({
            mutation: loginMutation,
            variables: { usernameOrEmail: this.email, password: this.password },
          })
          .catch((e) => {
            this.formError = UNKNOWN_ERROR;
          });
      })
      .then((response) => {
        if (response && response.data && response.data.getAuthToken) {
          this.$store.dispatch('auth/setAuthToken', response.data.getAuthToken);
        }
        this.$emit('done');

        this.loading = false;
      })
      .catch((e) => {
        this.formError = parseError(e) || UNKNOWN_ERROR;
        this.loading = false;
      });
  }

  get hasErrors() {
    return Object.values(this.fieldErrors).some((v) => v != null && v.length > 0);
  }

  public validateFields() {
    this.validateEmail();
    // this.validateUsername();
    this.validatePassword();
    this.validateName();
    this.validateCenter();
  }

  public validateEmail() {
    const v = (this.email || '').trim();

    let err = null;
    if (v.length < 1) {
      err = `Your email is required.`;
    }

    Vue.set(this.fieldErrors, 'email', err);
  }

  public validateUsername() {
    const v = (this.username || '').trim();

    let err = null;
    if (v.length < 1) {
      err = `Your username is required.`;
    }

    Vue.set(this.fieldErrors, 'username', err);
  }

  public validatePassword() {
    const v = (this.password || '').trim();

    let err = null;
    if (v.length < 1) {
      err = `Your password is required.`;
    }

    Vue.set(this.fieldErrors, 'password', err);
  }

  public validateName() {
    const v = (this.name || '').trim();

    let err = null;
    if (v.length < 1) {
      err = `Please enter your full name.`;
    }

    Vue.set(this.fieldErrors, 'name', err);
  }

  public validateCenter() {
    let err = null;
    if (this.centerId == null) {
      err = 'Please select a home center.';
    }

    Vue.set(this.fieldErrors, 'centerId', err);
  }

  @Watch('email')
  public onEmailChange() {
    this.validateEmail();
  }

  // @Watch('username')
  // public onUsernameChange() {
  //   this.validateUsername();
  // }

  @Watch('password')
  public onPasswordChange() {
    this.validatePassword();
  }

  @Watch('name')
  public onNameChange() {
    this.validateName();
  }

  @Watch('centerId')
  public onCenterChange() {
    this.validateCenter();
  }
}
